"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PharmacyLabel = void 0;
const barcode_1 = require("client/components/barcode");
const store_1 = require("client/modules/orders/store");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
require("./pharmacy-label.less");
const attrsInLabel = [
    "description",
    "dosage_and_administration",
    "how_supplied",
    "precautions",
    "storage_and_handling",
    "warnings"
];
let PharmacyLabel = class PharmacyLabel extends react_1.Component {
    constructor(props) {
        super(props);
        this.renderPatientReceipt = (claim, inventory, order, patient, provider, orderSite) => {
            const address2 = patient.address2 ? ` ${patient.address2}` : "";
            return (React.createElement("div", { className: "pharmacy-label__patient-receipt" },
                React.createElement("table", { className: "wide" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("b", { className: "underline" }, "Patient Receipt"),
                                React.createElement("br", null),
                                orderSite.name,
                                React.createElement("br", null),
                                orderSite.address,
                                React.createElement("br", null),
                                `${orderSite.city} ${orderSite.state} ${orderSite.zip}`,
                                React.createElement("br", null),
                                "Provider:",
                                " ",
                                React.createElement("b", { className: "uppercase" }, `${provider.lastName}, ${provider.firstName} ${provider.title}`),
                                React.createElement("br", null),
                                "Patient:",
                                " ",
                                React.createElement("b", { className: "uppercase" }, `${patient.firstName} ${patient.lastName}`),
                                React.createElement("br", null),
                                React.createElement("span", null, `${patient.address}${address2} ${patient.city} ${patient.state} ${patient.zip}`),
                                React.createElement("br", null),
                                React.createElement("span", null,
                                    React.createElement("b", null, "Home:"),
                                    ` ${patient.phone}`),
                                React.createElement("br", null),
                                React.createElement("b", null,
                                    "Rx:",
                                    claim.id),
                                "\u00A0 Date:",
                                moment(order.createDate).format("MMM DD, YYYY"),
                                React.createElement("br", null),
                                React.createElement("b", { className: "uppercase nowrap" }, `${inventory.name} ${claim.quantity} x ${inventory.strength}${inventory.unit} ${inventory.dosage}`),
                                React.createElement("br", null),
                                "NDC:",
                                inventory.package,
                                " Manu NDC:",
                                inventory.package,
                                React.createElement("br", null),
                                inventory.defaultSig && React.createElement("b", null, inventory.defaultSig),
                                inventory.defaultSig2 && React.createElement("b", null, inventory.defaultSig2),
                                inventory.defaultSig3 && React.createElement("b", null, inventory.defaultSig3),
                                React.createElement("br", null),
                                "Lot#: ",
                                claim.lotNum,
                                React.createElement("br", null),
                                React.createElement("b", null,
                                    "Payment: $",
                                    claim.totalAmount)))))));
        };
        this.renderTopRight = (claim, inventory, order, patient, provider, orderSite) => {
            const address2 = patient.address2 ? ` ${patient.address2}` : "";
            return (React.createElement("div", { className: "pharmacy-label__top-right" },
                React.createElement("table", { className: "wide" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2 },
                                React.createElement("table", { className: "wide" },
                                    React.createElement("tbody", null,
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "small" },
                                                "Rx:",
                                                claim.id),
                                            React.createElement("td", { className: "right small wide" },
                                                "Date:",
                                                " ",
                                                `${moment(order.createDate).format("MM/DD/YYYY")} `)))))),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2, className: "large uppercase" },
                                React.createElement("b", null, inventory.name))),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2, className: "large right" }, `${claim.quantity} x ${inventory.strength}${inventory.unit} ${inventory.dosage}`)),
                        inventory.defaultSig && (React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2, className: "small" },
                                React.createElement("b", null, inventory.defaultSig)))),
                        inventory.defaultSig2 && (React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2, className: "small" },
                                React.createElement("b", null, inventory.defaultSig2)))),
                        inventory.defaultSig3 && (React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2, className: "small" },
                                React.createElement("b", null, inventory.defaultSig3)))),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2 },
                                "NDC: ",
                                inventory.package,
                                " Lot: ",
                                claim.lotNum)),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2, className: "uppercase right" }, `${provider.lastName}, ${provider.firstName} ${provider.title}`)),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2 }, orderSite.name)),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2 }, orderSite.address)),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2 }, `${orderSite.city}, ${orderSite.state} ${orderSite.zip}`)),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2, className: "right" },
                                "Discard After: ",
                                moment(claim.expireDate).format("MM/DD/YYYY"))),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2, className: "right" },
                                "Medication Info: ",
                                orderSite.phone)),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("span", null,
                                    React.createElement("b", { className: "large uppercase" }, `${patient.lastName}, ${patient.firstName} `)),
                                "(DOB: ",
                                moment(patient.birthDate).format("MM/DD/YYYY"),
                                ")")),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 2, className: "upper" }, `${patient.address}${address2} ${patient.city} ${patient.state} ${patient.zip}`))))));
        };
        this.renderBottomLeft = (claim, inventory, order, patient, provider) => (React.createElement("div", { className: "pharmacy-label__bottom-left" },
            React.createElement("table", { className: "wide" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            "Rx:",
                            claim.id,
                            ` ${moment(order.createDate).format("MM/DD/YYYY")} `)),
                    claim.inventory.defaultSig && (React.createElement("tr", null,
                        React.createElement("td", { className: "wide" }, claim.inventory.defaultSig))),
                    claim.inventory.defaultSig2 && (React.createElement("tr", null,
                        React.createElement("td", { className: "wide" }, claim.inventory.defaultSig2))),
                    claim.inventory.defaultSig3 && (React.createElement("tr", null,
                        React.createElement("td", { className: "wide" }, claim.inventory.defaultSig3))),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "wide" },
                            React.createElement("span", { className: "uppercase" }, `${provider.lastName}, ${provider.firstName} ${provider.title}`),
                            React.createElement("br", null),
                            React.createElement("span", { className: "uppercase" }, `${patient.firstName} ${patient.lastName} DOB:${moment(patient.birthDate).format("MM/DD/YYYY")}`),
                            React.createElement("br", null),
                            "NDC: ",
                            inventory.package,
                            " Lot: ",
                            claim.lotNum,
                            " ",
                            moment(order.createDate).format("MM/DD/YYYY"),
                            React.createElement("br", null),
                            "Manu NDC: ",
                            inventory.package,
                            React.createElement("br", null),
                            React.createElement("span", { className: "uppercase" }, `${inventory.name} ${claim.quantity} x ${inventory.strength}${inventory.unit} ${inventory.dosage}`)))))));
        this.renderBarcode = (inventory, patient) => (React.createElement("div", { className: "pharmacy-label__barcode" },
            React.createElement("br", null),
            React.createElement("table", { className: "wide" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { className: "center" },
                            React.createElement("b", null, `${patient.firstName} ${patient.lastName} ${moment(patient.birthDate).format("MM/DD/YYYY")}`),
                            React.createElement("br", null),
                            React.createElement(barcode_1.UiBarcode, { background: "transparent", displayValue: true, height: 60, lineColor: "#26324e", value: inventory.barCode, margin: 0, width: 1 })))))));
        this.renderBottomRight = (claim, inventory, order, patient) => (React.createElement("div", { className: "pharmacy-label__bottom-right" },
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { className: "nowrap" },
                            React.createElement("div", null,
                                "Rx:",
                                claim.id,
                                " ",
                                inventory.package,
                                " ",
                                moment(order.createDate).format("MM/DD/YYYY h:mm A"),
                                React.createElement("br", null),
                                React.createElement("span", { className: "uppercase" }, `${inventory.name} ${claim.quantity} x ${inventory.strength}${inventory.unit} ${inventory.dosage}`),
                                " ",
                                "Lot: ",
                                claim.lotNum,
                                React.createElement("br", null),
                                `${patient.firstName} ${patient.lastName} ${moment(patient.birthDate).format("MM/DD/YYYY")}`,
                                React.createElement("br", null),
                                "Do you require additional counseling for this medication? YES / NO",
                                React.createElement("br", null),
                                "Signature:")))))));
        this.renderBottom = (inventory) => {
            const hasData = Object.keys(this.props.monograph).length !== 0;
            let result = {};
            if (hasData) {
                result = this.props.monograph.results[0];
            }
            return (React.createElement("div", { className: "pharmacy-label__bottom" },
                React.createElement("table", { className: "wide" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 3, className: "center" },
                                React.createElement("b", null, "Call your doctor for medical advice about side effects. You may report side effects to FDA at 1-800-FDA-1088"))),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 3, className: "center" },
                                React.createElement("b", null,
                                    "2Patient Information for",
                                    " ",
                                    React.createElement("span", { className: "uppercase" }, `${inventory.name} ${inventory.strength}${inventory.unit} ${inventory.dosage}`)))),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "twentypercent" }),
                            React.createElement("td", { className: "monoful" },
                                React.createElement("br", null),
                                React.createElement("span", { className: "uppercase" }, inventory.name),
                                React.createElement("br", null),
                                "----------",
                                attrsInLabel.map((attr, index) => {
                                    if (result.hasOwnProperty(attr)) {
                                        let text = Array.isArray(result[attr])
                                            ? result[attr].join(" ")
                                            : result[attr];
                                        text = text.toString();
                                        const newAttr = attr.split("_").join(" ");
                                        const attrIndex = text.search(new RegExp(newAttr, "i"));
                                        text =
                                            attrIndex > -1
                                                ? text.substring(attrIndex + attr.length)
                                                : text;
                                        return (React.createElement("div", { key: index },
                                            React.createElement("span", { className: "uppercase" }, newAttr.split("_").join(" ")),
                                            React.createElement("br", null),
                                            text.replace("Section Text", "")));
                                    }
                                    return null;
                                })),
                            React.createElement("td", { className: "twentypercent" }))))));
        };
    }
    render() {
        const claim = store_1.ordersStore.claim.value;
        const inventory = claim && claim.inventory;
        const patient = claim && claim.order.patient;
        const provider = claim && claim.order.provider;
        const orderSite = claim && claim.order.site;
        return (React.createElement("div", { className: "pharmacy-label" },
            React.createElement("div", { className: "pharmacy-label__container" },
                React.createElement("div", { className: "pharmacy-label__first-row" },
                    claim &&
                        inventory &&
                        patient &&
                        provider &&
                        orderSite &&
                        this.renderPatientReceipt(claim, inventory, claim.order, patient, provider, orderSite),
                    React.createElement("div", { className: "pharmacy-label__placeholder" }),
                    claim &&
                        inventory &&
                        patient &&
                        provider &&
                        orderSite &&
                        this.renderTopRight(claim, inventory, claim.order, patient, provider, orderSite)),
                React.createElement("div", { className: "pharmacy-label__second-row" },
                    claim &&
                        inventory &&
                        patient &&
                        provider &&
                        this.renderBottomLeft(claim, inventory, claim.order, patient, provider),
                    inventory && patient && this.renderBarcode(inventory, patient),
                    claim &&
                        claim.order &&
                        inventory &&
                        patient &&
                        this.renderBottomRight(claim, inventory, claim.order, patient)),
                React.createElement("br", null),
                React.createElement("br", null),
                inventory && this.renderBottom(inventory))));
    }
};
PharmacyLabel = __decorate([
    mobx_react_1.observer
], PharmacyLabel);
exports.PharmacyLabel = PharmacyLabel;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/pharmacy-label/pharmacy-label.tsx
// module id = 3733
// module chunks = 0